<template>
  <div>
    <NavigationBar></NavigationBar>
    <BoardContent></BoardContent>
    <FooterView></FooterView>
  </div>
</template>
<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import FooterView from '@/components/shared/Footer/Footer-view.vue';
import BoardContent from "@/components/Board/Board-content.vue";

export default {
  name: 'BoardViews',

  components: {
    BoardContent,
    NavigationBar,
    FooterView
  }
}
</script>